var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Green/Checkmark-circle Copy 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Avenu---Visual-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.0-Payors",
    transform: "translate(-555.000000, -3924.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Green/Checkmark-circle",
    transform: "translate(555.000000, 3924.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#72BFB9",
    fillRule: "evenodd",
    cx: 17.5,
    cy: 17.5,
    r: 17.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6897078,23 L15.6881392,23 C15.5177553,23 15.3541428,22.9304184 15.2337734,22.8095039 L10.1868591,17.7042352 C9.93623763,17.4509581 9.93832919,17.0422646 10.1894736,16.7916132 C10.4432324,16.5388613 10.8486033,16.541487 11.098179,16.7942389 L15.6907275,21.4406104 L24.9029362,12.1891701 C25.1546035,11.9369433 25.5610202,11.9369433 25.8116417,12.1891701 C26.0627861,12.4408717 26.0627861,12.8495653 25.8116417,13.1017921 L16.1440475,22.8111056 C16.0236781,22.9319676 15.8600918,23 15.6897078,23 Z",
    id: "Shape",
    stroke: "#FFFFFF",
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheckmark);
export default __webpack_public_path__ + "static/media/circle-checkmark.67138b29c396e1ac4ab1e0e0d2bbff9b.svg";
export { ForwardRef as ReactComponent };